import moment from "moment";
import { nanoid } from "nanoid";
import constants from "../constants";
import { getDataFromStorage } from "../util";
import useAxiosPrivate from "./useAxiosPrivate";
import AlertContext from "../context/AlertContext";
import { useContext, useMemo, useRef, useState } from "react";
import useCommonFunctionHooks from "./useCommonFunctionHooks";
import CodingHeaderHooks from "./CodingPage/CodingHeaderHooks";
import useS3FileManagement from "./useS3FileManagement";

export default function CommentsHooks() {
  const Alert = useContext(AlertContext);

  const axios = useAxiosPrivate();
  const { getLearnerId } = CodingHeaderHooks();
  const { getCatchBlockDetails, getHeaderDetailsForAxios } =
    useCommonFunctionHooks();
  const { getPreSignedUrl, onMultiPartUpload } = useS3FileManagement();

  const inputRef = useRef(null);

  const [editedComment, setEditedComment] = useState("");
  const [cursorPosition, setCursorPosition] = useState(0);
  const [editingCommentIndex, setEditingCommentIndex] = useState(null);

  const changeComments = (event) => {
    Alert.setComment(event.target.value);
  };

  const editComment = (index) => {
    setEditingCommentIndex(index);
    setEditedComment(Alert.commentsData[index].comments);
    setCursorPosition(Alert.commentsData[index].comments.length);
    focusInput();
  };

  const focusInput = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  const ignoreEditedComment = () => {
    setCursorPosition(0);
    setEditingCommentIndex(null);
    setEditedComment("");
  };

  const handleCommentAttachment = (event) => {
    let commentedDate = String(new Date());
    let attachments = [...Alert.commentAttachment];
    let files = Array.from(event.target.files);

    for (let i = 0; i < files.length; i++) {
      let attachment = { id: nanoid(), file: files[i], date: commentedDate };
      attachments.push(attachment);
    }

    Alert.setCommentAttachment(attachments);
    event.target.value = "";
  };

  const handleDeleteCommentAttachment = (attachmentId) => {
    Alert.setCommentAttachment((prevAttachment) =>
      prevAttachment.filter((attachment) => attachment.id !== attachmentId)
    );
  };

  const handleCommentChange = (e) => {
    e.preventDefault();

    const { value, selectionStart } = e.target;

    setEditedComment(value);

    // Update the cursor position

    setCursorPosition(selectionStart);
    focusInput();
  };

  const toggleDrawer =
    (anchor, open, isCommentButton = false) =>
    (event) => {
      if (isCommentButton) {
        handleGetAllCommentsData();
        Alert.setComment("");
        Alert.setCommentAttachment([]);
        Alert.setShowComments(!Alert.showComments);
      } else {
        if (
          event.type === "keydown" &&
          (event.key === "Tab" || event.key === "Shift")
        ) {
          return;
        }

        Alert.setComment("");
        Alert.setCommentAttachment([]);
        // if(!open){
        //   Alert.setCommentState([]);
        // }
        Alert.setShowComments(!Alert.showComments);
      }
    };

  // const attachments = useMemo(() => {
  //   return Alert.testData.libtype === constants.libTypeIds.ASSIGNMENT &&
  //     Alert.commentsData?.commentAttachment &&
  //     Alert.commentsData?.commentAttachment
  //     ? typeof Alert.commentsData?.commentAttachment === "string"
  //       ? JSON.parse(Alert.commentsData?.commentAttachment)
  //       : Alert.commentsData?.commentAttachment
  //     : [];
  // }, [Alert.commentsData?.commentAttachment, Alert.testData.libtype]);

  const handleGetAllCommentsData = async () => {
    try {
      Alert.setIsLoaded(true);
      // Alert.setCommentState([]);

      const response = await axios({
        method: "get",
        url: `node/admin/test/comments?libid=${Alert.libId}&testid=${
          Alert.showBreadCrumbsData.type === constants.libTypeIds.MCQ ||
          Alert.showBreadCrumbsData.type === constants.libTypeIds.DESCRIPTIVE ||
          Alert.showBreadCrumbsData.type === constants.libTypeIds.CODING_SNIPPET
            ? Alert.showBreadCrumbsData.testId
            : Alert.showBreadCrumbsData.type === constants.libTypeIds.ASSIGNMENT
            ? "undefined"
            : Alert.showBreadCrumbsData.testId
        }&learnerid=${Alert.showBreadCrumbsData.learnerId}&contentType=${
          Alert.showBreadCrumbsData.type
        }`,
        headers: getHeaderDetailsForAxios().headers,
      });
      // Alert.setCommentsData(reponse?.data);
      Alert.setCommentState(response?.data);
      // setCommentState(reponse?.data);
    } catch (error) {
      getCatchBlockDetails(error);
    } finally {
      Alert.setIsLoaded(false);
    }
  };

  const handleAddComments = async (event, button) => {
    if (
      button ||
      button === "score" ||
      (event.ctrlKey && event.key === "Enter")
    ) {
      if (
        Alert.comment !== "" &&
        Alert.comment !== undefined &&
        Alert.comment !== null
      ) {
        try {
          Alert.setIsLoaded(true);

          let picType = [];
          let form = new FormData();

          form.append("comments", Alert.comment);
          form.append("contentType", picType);
          form.append("lpid", Alert.showBreadCrumbsData.lpId);
          form.append("libtype", Alert.showBreadCrumbsData.type);
          form.append("creatorid", getDataFromStorage("learnerid"));
          form.append("learnerid", Alert.showBreadCrumbsData.learnerId);

          if (
            Alert.showBreadCrumbsData.type === constants.libTypeIds.ASSIGNMENT
          ) {
            form.append("questionid", Alert.showBreadCrumbsData.testId);
          } else if (
            Alert.showBreadCrumbsData.type === constants.libTypeIds.MCQ ||
            Alert.showBreadCrumbsData.type === constants.libTypeIds.SQL ||
            Alert.showBreadCrumbsData.type === constants.libTypeIds.DESCRIPTIVE ||
            Alert.showBreadCrumbsData.type === constants.libTypeIds.CODING_SNIPPET
          ) {
            form.append("testid", Alert.showBreadCrumbsData.testId);
          } else {
            form.append("testid", Alert.showBreadCrumbsData.testId);
            form.append("questionid", Alert.showBreadCrumbsData.questionId);
          }

          if (Alert.commentAttachment.length > 0) {
            for (let i = 0; i < Alert.commentAttachment.length; i++) {
              form.append(
                Alert.commentAttachment[i].file.name,
                Alert.commentAttachment[i].file
              );
              picType.push(
                Alert.commentAttachment[i].file.name.replace(/^.*\./, "")
              );
            }
          }

          let getLinkCount = 0;
          let key = [];

          for (let i = 0; i < Alert.commentAttachment.length; i++) {
            key.push(
              `library/submission/${getLearnerId()}/${
                Alert.commentAttachment[i].file.name
              }`
            );
            const response = await onMultiPartUpload(
              key[i],
              Alert.commentAttachment[i].file
            );
            Alert.commentAttachment[i].key = key[i];
          }
          form.append("attachmentkeys", JSON.stringify(key));
          let response = await axios({
            data: form,
            method: "post",
            url: "node/admin/test/comment",
            headers: getHeaderDetailsForAxios("multipart").headers,
          });
          if (response.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
            Alert.setShowComments(false);

            if (button === "score") {
              Alert.setIsComment(true);
              Alert.setComment(Alert.comment);
              Alert.setShowNotify({
                show: true,
                title: "Info",
                msg: "Score added successfully",
              });
            } else {
              Alert.setComment("");

              if (button === "reject") {
                return true;
              } else {
                Alert.setShowNotify({
                  show: true,
                  title: "Info",
                  msg: "Comment added successfully",
                });
              }
            }

            if (getLinkCount === Alert.commentAttachment.length) {
              Alert.commentsData.push({
                comments: Alert.comment,
                date: String(new Date()),
                id: response.data.data.insertId,
                createdby: getDataFromStorage("name"),
                commentAttachment: Alert.commentAttachment,
                creatorid: getDataFromStorage("learnerid"),
                // key:""
              });

              Alert.setCommentAttachment([]);
            }
          }
        } catch (error) {
          getCatchBlockDetails(error);
        } finally {
          Alert.setIsLoaded(false);
        }
      } else {
        Alert.setShowNotify({
          show: true,
          title: "Warning",
          msg: "Please enter the comments",
        });
      }
    }
  };

  const saveEditedComment = async () => {
    const updatedComments = [...Alert.commentsData];

    updatedComments[editingCommentIndex].comments = editedComment;
    updatedComments[editingCommentIndex].date = moment().format(
      "YYYY-MM-DD HH:mm:ss"
    );

    // Perform any necessary API call to update the comment on the backend

    let picType = [];
    let form = new FormData();

    form.append("isupdate", true);
    form.append("contentType", picType);
    form.append("lpid", Alert.showBreadCrumbsData.lpId);
    form.append("libtype", Alert.showBreadCrumbsData.type);
    form.append("learnerid", Alert.showBreadCrumbsData.learnerId);
    form.append("creatorid", getDataFromStorage("learnerid"));
    form.append("id", updatedComments[editingCommentIndex].id);
    form.append("comments", updatedComments[editingCommentIndex].comments);

    if (Alert.showBreadCrumbsData.type === constants.libTypeIds.ASSIGNMENT) {
      form.append("questionid", Alert.showBreadCrumbsData.testId);
    } else if (
      Alert.showBreadCrumbsData.type === constants.libTypeIds.MCQ ||
      Alert.showBreadCrumbsData.type === constants.libTypeIds.DESCRIPTIVE ||
      Alert.showBreadCrumbsData.type === constants.libTypeIds.CODING_SNIPPET
    ) {
      form.append("testid", Alert.showBreadCrumbsData.testId);
    } else {
      form.append("testid", Alert.showBreadCrumbsData.testId);
      form.append("questionid", Alert.showBreadCrumbsData.questionId);
    }

    if (Alert.commentAttachment.length > 0) {
      for (let i = 0; i < Alert.commentAttachment.length; i++) {
        form.append(
          Alert.commentAttachment[i].file.name,
          Alert.commentAttachment[i].file
        );
        picType.push(Alert.commentAttachment[i].file.name.replace(/^.*\./, ""));
      }
    }

    await axios({
      data: form,
      method: "post",
      url: "node/admin/test/comment",
      headers: {
        "Content-type": "multipart/form-data",
      },
    });

    // Clear editing state and setcursor position

    setCursorPosition(0);
    setEditedComment("");
    setEditingCommentIndex(null);
  };

  const deleteComment = async (index) => {
    let temp = [...Alert.commentsData];

    temp.splice(index, 1);
    Alert.setCommentsData(temp);

    let picType = [];
    let form = new FormData();

    form.append("isdelete", true);
    form.append("contentType", picType);
    form.append("id", Alert.commentsData[index].id);
    form.append("libtype", Alert.showBreadCrumbsData.type);
    form.append("creatorid", getDataFromStorage("learnerid"));
    form.append("learnerid", Alert.showBreadCrumbsData.learnerId);

    if (Alert.showBreadCrumbsData.type === constants.libTypeIds.ASSIGNMENT) {
      form.append("questionid", Alert.showBreadCrumbsData.testId);
    } else if (
      Alert.showBreadCrumbsData.type === constants.libTypeIds.MCQ ||
      Alert.showBreadCrumbsData.type === constants.libTypeIds.DESCRIPTIVE ||
      Alert.showBreadCrumbsData.type === constants.libTypeIds.CODING_SNIPPET
    ) {
      form.append("testid", Alert.showBreadCrumbsData.testId);
    } else {
      form.append("testid", Alert.showBreadCrumbsData.testId);
      form.append("questionid", Alert.showBreadCrumbsData.questionId);
    }

    if (Alert.commentAttachment.length > 0) {
      for (let i = 0; i < Alert.commentAttachment.length; i++) {
        form.append(
          Alert.commentAttachment[i].file.name,
          Alert.commentAttachment[i].file
        );
        picType.push(Alert.commentAttachment[i].file.name.replace(/^.*\./, ""));
      }
    }

    await axios({
      data: form,
      method: "post",
      url: "node/admin/test/comment",
      headers: {
        "Content-type": "multipart/form-data",
      },
    });

    setEditedComment("");
    setEditingCommentIndex(null);
  };

  return {
    inputRef,
    focusInput,
    editComment,
    // attachments,
    toggleDrawer,
    deleteComment,
    editedComment,
    cursorPosition,
    changeComments,
    setEditedComment,
    saveEditedComment,
    handleAddComments,
    editingCommentIndex,
    handleCommentChange,
    ignoreEditedComment,
    setEditingCommentIndex,
    handleCommentAttachment,
    handleDeleteCommentAttachment,
  };
}
